import { render, staticRenderFns } from "./PatientHeader.vue?vue&type=template&id=7b4617fd&scoped=true&"
import script from "./PatientHeader.vue?vue&type=script&lang=js&"
export * from "./PatientHeader.vue?vue&type=script&lang=js&"
import style0 from "./PatientHeader.vue?vue&type=style&index=0&id=7b4617fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4617fd",
  null
  
)

export default component.exports